<template>
  <el-card class="card-horizontal" v-loading="isLoading">
    <a :href="usersCourse.url"  v-on:click.capture="isLoading = true">
      <el-row :gutter="20">
        <el-col :xs="{span: 12, offset: 6}" :sm="8" :md="4">
          <div class="card-horizontal__media">
            <img v-if="course.bigImage" :src="course.bigImage">
            <img v-else :src="fallbackJpg">
          </div>
        </el-col>
        <el-col :xs="24" :sm="16" :md="20">
          <header class="card-horizontal__header">
            <h4 class="h4 font-family-body">{{ course.title }}</h4>
            <div v-if="course.fullLine">
              <img :src="fullLineRibbon"/>
              <span class="full-line-title">
                {{ course.fullLine }}
            </span>
            </div>
            <h4 class="h6 font-family-body">{{ course.description }}</h4>
            <div class="progress-text">{{ percentComplete }}{{ $t('trainingPercent') }}</div>
          </header>
          <div class="card-horizontal__actions">
            <span v-if="course.isFullLineSummary" class="card__link-emphasized">{{ $t('trainingModuleInProgressFullLineCardCta') }}</span>
            <span v-else class="card-horizontal__link-emphasized">{{ $t('trainingModuleInProgressCardCta') }}</span>
          </div>
        </el-col>
      </el-row>
    </a>
  </el-card>
</template>

<script>
  import fallbackJpg from '@/assets/images/fallbackSquare.jpg';
  import api from '@/api';
  import router from '@/router';
  import fullLineRibbon from '@/assets/images/full-line-ribbon.svg';
  import loadingStateReset from '@/mixins/loadingStateReset';

  export default {
    name : 'TrainingInProgressCatalogCard',
    mixins: [loadingStateReset],
    data() {
      return {
        fallbackJpg,
        isLoading : false,
        fullLineRibbon,
      }
    },
    props : {
      course : Object,
      usersCourse: Object,
    },
    computed : {
      percentComplete : function() {
        if (this.usersCourse.status == 'failed') {
          return 0;
        }

        return this.usersCourse.percent;
      },
    }
  };
</script>

<style lang="scss" scoped>
  @import 'element-theme-chalk/src/mixins/mixins.scss';
  .module {

    &__link {
      overflow: hidden;
      display: block;
      position: relative;
      width: 100%;
      height: 100%;
      cursor: pointer;
      text-decoration: none;
    }
  }

  .card-horizontal {
    &__link-locked::after {
      content: none;
    }

    .card-horizontal__media {
      @include res(xs) {
        margin-bottom: 30px;
      }

      img {
        object-position: bottom;
        object-fit: contain;
      }
    }
  }

  .full-line-title {
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    color: #D31F25;
    text-transform: uppercase;
    vertical-align: text-top;
  }
</style>